export default [{
  path: '/district',
  name: 'district',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/district/index')
}]
